import { render, staticRenderFns } from "./ListaCostos.vue?vue&type=template&id=274f0968&scoped=true&"
import script from "./ListaCostos.vue?vue&type=script&lang=js&"
export * from "./ListaCostos.vue?vue&type=script&lang=js&"
import style0 from "./ListaCostos.vue?vue&type=style&index=0&id=274f0968&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274f0968",
  null
  
)

export default component.exports